/**
 * 工程项目管理 接口
 */
 import axios from '../request';
 export default{
    /**
     * 项目管理
     */
    // 查询项目管理信息
    searchProjects: params =>
        axios.post('/engineering/project/projectList', params),
    // 添加项目管理信息
    insertProjects: params =>
        axios.post('/engineering/project/projectInsert', params),
    // 修改项目管理信息
    updateProjects: params =>
        axios.post('/engineering/project/projectUpdate', params),
    // 项目管理信息详情
    detailsProjects: params =>
        axios.get('/engineering/project/projectInfo', {params}),
    // 删除项目管理信息
    deleteProjects: params =>
        axios.get('/engineering/project/projectDel', {params}),
    //获取所有项目下拉 
    getAllProjects: params =>
        axios.get('/engineering/project/projectListPull', {params}),

    /**
     * 标段管理
     */
    // 查询标段管理信息
    searchSegment: params =>
        axios.post('/engineering/segment/segmentList', params),
    // 添加标段管理信息
    insertSegment: params =>
        axios.post('/engineering/segment/segmentInsert', params),
    // 修改标段管理信息
    updateSegment: params =>
        axios.post('/engineering/segment/segmentUpdate', params),
    // 标段信息详情
    detailsSegment: params =>
        axios.get('/engineering/segment/segmentInfo', {params}),
    // 删除标段管理信息
    deleteSegment: params =>
        axios.get('/engineering/segment/segmentDel', {params}),

    /**
     * 人员下拉框
     */
    //所有人员
    getPersonsList: params =>
        axios.post('/staff/platUser/pulldown', params),
 }